import { createClient, Entry } from 'contentful';
import {
  BlogPostType,
  HomePageType,
  ContentPageType,
  BlogPostAudienceType
} from 'types/Content';

const {
  REACT_APP_CONTENTFUL_SPACE_ID,
  REACT_APP_CONTENTFUL_ACCESS_TOKEN
} = process.env;

const client = createClient({
  space: REACT_APP_CONTENTFUL_SPACE_ID ? REACT_APP_CONTENTFUL_SPACE_ID : '',
  accessToken: REACT_APP_CONTENTFUL_ACCESS_TOKEN
    ? REACT_APP_CONTENTFUL_ACCESS_TOKEN
    : ''
});

export const getHomepage = async (): Promise<
  Entry<HomePageType> | undefined
> => {
  try {
    const entry = await client.getEntry<HomePageType>('GpwUye3jfBqUOS8R0L4Zf');

    return entry;
  } catch (err) {
    return undefined;
  }
};

export const getBlogPost = async (
  slug: string
): Promise<Entry<BlogPostType> | undefined> => {
  try {
    const entries = await client.getEntries<BlogPostType>({
      content_type: 'blogPost',
      'fields.slug': slug
    });

    if (entries.items.length > 0) {
      const entry = entries.items[0];
      return entry;
    }
  } catch (err) {
    return undefined;
  }
};

export const getRecentBlogPosts = async (
  limit: number,
  audience?: BlogPostAudienceType
): Promise<Entry<BlogPostType>[]> => {
  let blogPosts: Entry<BlogPostType>[] = [];

  try {
    const entries = await client.getEntries<BlogPostType>({
      content_type: 'blogPost',
      order: '-fields.publishedDate',
      limit,
      'fields.audience': audience
    });

    if (entries.items.length > 0) {
      blogPosts = entries.items;
    }
  } catch (err) {
    return blogPosts;
  }

  return blogPosts;
};

export const getFeaturedBlogPosts = async (
  limit: number
): Promise<Entry<BlogPostType>[]> => {
  let blogPosts: Entry<BlogPostType>[] = [];

  try {
    const entries = await client.getEntries<BlogPostType>({
      content_type: 'blogPost',
      order: '-sys.createdAt',
      limit,
      'fields.featured': true
    });

    if (entries.items.length > 0) {
      blogPosts = entries.items;
    }
  } catch (err) {
    return blogPosts;
  }

  return blogPosts;
};

export const getContentPage = async (
  slug: string,
  content_type?: string,
  include?: number ,
): Promise<Entry<ContentPageType> | undefined> => {
  try {
    const entries = await client.getEntries<ContentPageType>({
      content_type:  content_type || 'contentPage',
      'fields.slug': slug,
      include: include || 1
    });

    if (entries.items.length > 0) {
      const entry = entries.items[0];
      return entry;
    }
  } catch (err) {
    return undefined;
  }
};
